export const EMPLOYEE_ANALYSIS_PAGE_TITLE = 'Employee Analysis'
